import { render } from "./ModalRecuperarContrasena.vue?vue&type=template&id=75387f84&scoped=true"
import script from "./ModalRecuperarContrasena.vue?vue&type=script&lang=js"
export * from "./ModalRecuperarContrasena.vue?vue&type=script&lang=js"

import "./ModalRecuperarContrasena.vue?vue&type=style&index=0&id=75387f84&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75387f84"]])

export default __exports__